<div *ngIf="!isDevToolsClosed" class="debug-mode"></div>
<router-outlet></router-outlet> <shell-overlay></shell-overlay>
